"use strict";

exports.__esModule = true;
exports.StandardTooltip = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = require("styled-components");
var _getTooltipPosition = require("./getTooltipPosition");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var StandardTooltip = exports.StandardTooltip = (0, _styledComponents.withTheme)(function (props) {
  var isActive = props.isActive,
    cursorXPosition = props.cursorXPosition,
    cursorYPosition = props.cursorYPosition,
    renderContent = props.renderContent,
    data = props.data,
    theme = props.theme,
    chartHeight = props.chartHeight,
    chartWidth = props.chartWidth,
    position = props.position,
    padding = props.padding;
  var tooltipContent = (0, _react.useRef)(null);
  var _useState = (0, _react.useState)(0),
    tooltipContentHeight = _useState[0],
    setTooltipContentHeight = _useState[1];
  var _useState2 = (0, _react.useState)(0),
    tooltipContentWidth = _useState2[0],
    setTooltipContentWidth = _useState2[1];
  (0, _react.useEffect)(function () {
    setTooltipContentWidth(tooltipContent.current ? tooltipContent.current.offsetWidth : 0);
    setTooltipContentHeight(tooltipContent.current ? tooltipContent.current.offsetHeight : 0);
  }, [tooltipContent.current]);
  if (!isActive || !data) {
    return null;
  }
  var _getTooltipContentPos = (0, _getTooltipPosition.getTooltipContentPosition)({
      cursorXPosition: cursorXPosition,
      width: chartWidth,
      tooltipContentWidth: tooltipContentWidth,
      cursorYPosition: cursorYPosition,
      height: chartHeight,
      tooltipContentHeight: tooltipContentHeight,
      position: position
    }),
    top = _getTooltipContentPos.top,
    left = _getTooltipContentPos.left,
    right = _getTooltipContentPos.right;
  var content = renderContent(data);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "tooltip",
    style: {
      position: "absolute",
      top: padding || "0px"
    }
  }, /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "tooltip-brush",
    style: {
      position: "absolute",
      display: "flex",
      flexDirection: "row",
      left: (cursorXPosition !== null ? cursorXPosition : 0) + "px",
      zIndex: 1,
      top: "0px",
      borderLeft: "1px solid " + theme.ToolTipHandleColor,
      height: chartHeight + "px"
    }
  }), /*#__PURE__*/_react["default"].createElement("div", {
    "data-testid": "tooltip-content",
    ref: tooltipContent,
    style: {
      padding: theme.uiModern ? "8px 10px" : "10px",
      width: "max-content",
      background: theme.TooltipContentBackgroundColor,
      position: "absolute",
      maxWidth: "350px",
      color: theme.TooltipContentColor,
      top: top ? top + "px" : "unset",
      left: left ? left + "px" : "unset",
      right: right ? right + "px" : "unset",
      fontSize: "12px",
      boxShadow: theme.uiModern ? theme.ChartTooltipShadow + ", inset 0 0 0 1px " + theme.ChartTooltipBorderColor : "0 0 0 1px rgba(16, 22, 26, 0.1), 0 2px 4px rgba(16, 22, 26, 0.2), 0 8px 24px rgba(16, 22, 26, 0.2)",
      borderRadius: theme.uiModern ? "8px" : "4px",
      zIndex: 1
    }
  }, content));
});